import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { isMyCommissionPath, staffSearchSchema } from '@/features/staff-commission';
import { seesOwnCommissionOnly, sessionQuery } from '@/shared/auth';

/** Staff / agent commission (payable). Separate from Collections (bank commission receivable). */
export const Route = createFileRoute('/_app/staff-commission')({
  validateSearch: staffSearchSchema,
  staticData: { crumb: 'nav.staffCommission', crumbTo: '/staff-commission' },
  beforeLoad: async ({ context, location, search }) => {
    await requirePermission(context.queryClient, 'staff_commission.view', 'Staff commission');
    // My commission is one page: rules, payout runs and other people's lists lead back to it.
    const session = await context.queryClient.query({ ...sessionQuery, staleTime: 'static' });
    if (seesOwnCommissionOnly(session) && !isMyCommissionPath(location.pathname, session.user.id)) {
      throw redirect({ to: '/staff-commission', search: { period: search.period }, replace: true });
    }
  },
  component: Outlet,
});
